// extracted by mini-css-extract-plugin
export default {"body":"body-mV9Vc","inputContainer":"inputContainer-IDS3G","inputField":"inputField-VQTnp","clear":"clear-fjxD0","counter":"counter-lawhD"};